/**
 * Leaderboard API client
 * Handles leaderboard retrieval
 */
import type { ApiResponse, LeaderboardEntry } from './types';
import { apiClient } from './client';

/**
 * Get the leaderboard for a pool
 * @param poolId Pool identifier
 * @returns Leaderboard entries sorted by rank
 */
export async function getLeaderboard(
  poolId: string
): Promise<ApiResponse<LeaderboardEntry[]>> {
  return apiClient.get<LeaderboardEntry[]>(`/pools/${poolId}/leaderboard`);
}
